import ITract from './ITract';

export default class Tract implements ITract {
    id: number;
    tractName: string;
    tractNumber: number;
    grossAcres: string;
    leasedAcres: string;
    hbpAcres: string;
    section: number;
    sectionNumber: number;
    legalDescription: string;
    ownershipType: string;
    isPlotted: string;
    maxOwnershipInterest: number;
    county: string;
    ownerCount: string;
    horizonCount: string;
    lastModified: string;
    isPartial: boolean;
    partialAcreage: number;
}

export class HorizonSummary {
    id: number;
    name: string;
    number: number;
    gross: number;
    hbp: number;
    open: number;
    leased: number;
}

export class TractSummary {
    id: string;
    tractNumber: number;
    isPlotted: string;
    legalDescription: string;
    lastModified: string;
    horizons: HorizonSummary[];
}



// WEBPACK FOOTER //
// ./src/models/Tract.ts